import { h } from 'preact';
export const Truck = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "1", y: "3", width: "15", height: "13" }),
        h("polygon", { points: "16 8 20 8 23 11 23 16 16 16 16 8" }),
        h("circle", { cx: "5.5", cy: "18.5", r: "2.5" }),
        h("circle", { cx: "18.5", cy: "18.5", r: "2.5" })));
};
//# sourceMappingURL=truck.js.map